// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import {FormGroup} from '../../form'
import DateTimePickerField from '../../form/DateTimePickerField'

import AccessTimeIcon from '@material-ui/icons/AccessTime'
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined'

import {change} from 'redux-form'

import './index.css'

class TimeInterval extends Component {
  renderDateTimePicker (name, date, dateIcon, time, timeIcon, inputReadOnly = false) {
    return (
      <FormGroup >
        <Field
          name={name}
          type='text'
          date={date}
          dateIcon={dateIcon}
          time={time}
          timeIcon={timeIcon}
          inputReadOnly={inputReadOnly}
          component={DateTimePickerField}
        />
      </FormGroup>
    )
  }

  render () {
    // eslint-disable-next-line no-unused-vars
    const {handleSubmit, initialValues} = this.props

    return (
      <div className='time-interval'>
        <form className='form time-interval-form inline-form round-border-fields' onSubmit={handleSubmit}>
          <div className='row with-background'>
            <div className='col-6 col-lg-3 row'>
              <div className='form-item'>
                <span>Start on &nbsp;</span>
                {this.renderDateTimePicker('startDate', true, <CalendarTodayOutlinedIcon/>, false, null)}
              </div>
            </div>
            <div className='col-6 col-lg-3 row'>
              <div className='form-item'>
                <span>at &nbsp;</span>
                {this.renderDateTimePicker('startTime', false, null, true, <AccessTimeIcon/>)}
              </div>
            </div>
            <div className='col-6 col-lg-3 row'>
              <div className='form-item'>
                <span>Stop on &nbsp;</span>
                <div>
                  {this.renderDateTimePicker('endDate', true, <CalendarTodayOutlinedIcon/>, false, null)}
                </div>
              </div>
            </div>
            <div className='col-6 col-lg-3 row'>
              <div className='form-item'>
                <span>at &nbsp;</span>
                {this.renderDateTimePicker('endTime', false, null, true, <AccessTimeIcon/>)}
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export function validateTimeInterval (values) {
  let ret = {}
  if (!values.startDate) {
    ret = {...ret, startDate: 'Start Date cannot be blank'}
  }

  if (!values.endDate) {
    ret = {...ret, endDate: 'End Date cannot be blank'}
  }

  if (!values.startTime) {
    ret = {...ret, startTime: 'Start Time cannot be blank'}
  }

  if (!values.endTime) {
    ret = {...ret, endTime: 'End Time cannot be blank'}
  }

  return ret
}

function onSubmit (values, dispatch) {
  dispatch((values))
}

function onChange (values, dispatch) {
  // This is being done to connect this form with FilterDetails since they are different components and forms
  // but they should behave like one
  dispatch(change('FilterDetails', 'startDate', values.startDate))
  dispatch(change('FilterDetails', 'endDate', values.endDate))
  dispatch(change('FilterDetails', 'startTime', values.startTime))
  dispatch(change('FilterDetails', 'endTime', values.endTime))
}

export default reduxForm({
  form: 'TimeInterval',
  onSubmit: onSubmit,
  onChange: onChange,
  validate: validateTimeInterval
})(TimeInterval)
